const DK = "rgba(0,0,0,";
const LT = "rgba(255,255,255,";

function Profile({ p }) {
  switch (p) {
    case "shaker":
      return <div className="absolute" style={{ inset: "13%", boxShadow: `inset 0 0 0 10px ${DK}0.16), inset 0 0 0 11px ${LT}0.12), inset 0 5px 12px ${DK}0.28)` }} />;
    case "slim":
      return <div className="absolute" style={{ inset: "15%", boxShadow: `inset 0 0 0 4px ${DK}0.22), inset 0 0 0 5px ${LT}0.10), inset 0 3px 8px ${DK}0.22)` }} />;
    case "fluted":
      return <div className="absolute" style={{ inset: "8%", background: `repeating-linear-gradient(90deg, ${DK}0.16) 0 5px, ${LT}0.10) 5px 7px, transparent 7px 16px)` }} />;
    case "routed":
      return <div className="absolute" style={{ inset: "10%", background: `repeating-linear-gradient(90deg, transparent 0 34px, ${DK}0.26) 34px 38px, ${LT}0.12) 38px 40px, transparent 40px 74px)` }} />;
    case "jpull":
      return <div className="absolute top-0 inset-x-0" style={{ height: "11%", background: `linear-gradient(180deg, ${DK}0.30), ${DK}0.06) 55%, ${LT}0.16))` }} />;
    case "arch":
      return (
        <>
          <div className="absolute left-1/2 -translate-x-1/2" style={{ top: "13%", width: "58%", height: "56%", borderRadius: "999px 999px 0 0", boxShadow: `inset 0 0 0 8px ${DK}0.18), inset 0 6px 14px ${DK}0.26)` }} />
          <div className="absolute left-1/2 -translate-x-1/2" style={{ bottom: "13%", width: "58%", height: "14%", boxShadow: `inset 0 0 0 8px ${DK}0.18)` }} />
        </>
      );
    case "chevron":
      return (
        <>
          <div className="absolute top-[9%] bottom-[9%] left-[9%] w-[41%]" style={{ background: `repeating-linear-gradient(45deg, ${DK}0.16) 0 9px, ${LT}0.09) 9px 18px)` }} />
          <div className="absolute top-[9%] bottom-[9%] right-[9%] w-[41%]" style={{ background: `repeating-linear-gradient(-45deg, ${DK}0.16) 0 9px, ${LT}0.09) 9px 18px)` }} />
        </>
      );
    case "bead":
      return (
        <>
          <div className="absolute" style={{ inset: "11%", boxShadow: `inset 0 0 0 3px ${DK}0.20), inset 0 0 0 4px ${LT}0.10)` }} />
          <div className="absolute" style={{ inset: "20%", boxShadow: `inset 0 0 0 2px ${DK}0.16), inset 0 3px 8px ${DK}0.20)` }} />
        </>
      );
    case "glass":
      return (
        <>
          <div className="absolute" style={{ inset: "10%", boxShadow: `inset 0 0 0 7px ${DK}0.20), inset 0 0 0 8px ${LT}0.10)` }} />
          <div className="absolute" style={{ inset: "20%", background: `linear-gradient(115deg, ${LT}0.55), ${LT}0.15) 42%, ${DK}0.10))`, boxShadow: `inset 0 0 0 1px ${DK}0.22), 0 3px 10px ${DK}0.22)` }} />
        </>
      );
    case "rib":
      return <div className="absolute" style={{ inset: "8%", background: `repeating-linear-gradient(180deg, ${DK}0.13) 0 10px, ${LT}0.10) 10px 14px, transparent 14px 30px)` }} />;
    case "raised":
      return (
        <>
          <div className="absolute" style={{ inset: "10%", boxShadow: `inset 0 0 0 8px ${DK}0.15), inset 0 0 0 9px ${LT}0.10)` }} />
          <div className="absolute" style={{ inset: "22%", boxShadow: `0 5px 12px ${DK}0.30), inset 0 1px 0 ${LT}0.22), inset 0 -3px 6px ${DK}0.15)` }} />
        </>
      );
    default:
      return null;
  }
}

export default function ShutterMock({ profile, color, texture, testid }) {
  return (
    <div data-testid={testid} className="relative w-full h-full overflow-hidden transition-colors duration-500" style={{ backgroundColor: color }}>
      {texture === "grain" && <div className="absolute inset-0 woodgrain opacity-80" />}
      {texture === "gloss" && (
        <div className="absolute inset-0" style={{ background: `linear-gradient(115deg, ${LT}0.42) 0%, ${LT}0.06) 34%, transparent 52%)` }} />
      )}
      {texture === "glass" && (
        <>
          <div className="absolute inset-0" style={{ background: `linear-gradient(115deg, ${LT}0.60) 0%, ${LT}0.10) 45%, transparent 60%)` }} />
          <div className="absolute inset-0" style={{ background: `linear-gradient(0deg, ${DK}0.16), transparent 40%)` }} />
        </>
      )}
      {texture === "stone" && (
        <div className="absolute inset-0 opacity-40" style={{ background: `repeating-linear-gradient(63deg, transparent 0 34px, ${LT}0.35) 34px 36px, transparent 36px 90px, ${DK}0.20) 90px 91px, transparent 91px 160px)` }} />
      )}
      {texture === "smooth" && (
        <div className="absolute inset-0" style={{ background: `linear-gradient(160deg, ${LT}0.14), transparent 45%, ${DK}0.09))` }} />
      )}
      <Profile p={profile} />
      <div className="absolute inset-0 pointer-events-none" style={{ boxShadow: `inset 0 0 0 1px ${DK}0.16), inset 0 2px 5px ${LT}0.16), inset 0 -8px 16px ${DK}0.20)` }} />
    </div>
  );
}
